'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// ./node_modules/querystring-es3/index.js
// module id = 1nuA
// module chunks = 0 1 2 3 4 5 6